<template>
  <div class="s-video">
    <!-- <div class="close iconfont icon-close" @click="hide"></div> -->
    <sRightmenu curMenu="ar" @change="menuClick" v-if="config.slideMenu"></sRightmenu>
      <van-swipe ref="videoSwi" vertical :loop="false" class="video-con" @change="onChange" :show-indicators="false" v-if="list && list.length">
        <van-swipe-item class="video-single" v-for="(item,index) in list">
          <div class="video-box">
            <van-loading v-if="showLoading && current == index"></van-loading>
            <video 
              v-if="current==index"
              :id="`${idName}${index}`" 
              :src="showpath + item.media_path"  
              webkit-playsinline playsinline x5-video-player-type="h5-page"
              object-fit="contain" 
              controls
              @loadeddata="loadEnd" 
              @canplay = "videoPlay"></video>
            <video 
              v-else-if = "current - index == 1|| index-current ==1"
              :id="`${idName}${index}`" 
              :src="showpath + item.media_path" 
               object-fit="contain" ></video>
            <video 
              v-else
              :id="`${idName}${index}`" 
              src="" 
               object-fit="contain" ></video>
          </div>
          <!-- webkit-playsinline playsinline x5-video-player-type="h5-page" -->
          
        </van-swipe-item>
      </van-swipe>
      <div class="build" v-if="develop">
        <div class="text">正在建设中</div>
      </div>
    <SurveyPop :videoId="videoId" :visible="surveyVisible" :key="surveyVisible"  @close="surveyHide" />
  </div>
</template>

<script>
import config from '@/config'
import sRightmenu from './s-rightmenu/s-rightmenu.vue'
import { mapGetters, mapMutations, mapState } from 'vuex'
import SurveyPop from './SurveyPop/index.vue'
import FoldTxt2 from './FoldTxt2.vue'
import videoMixin from '@/mixins/videoMixin'
import Rightbox from './s-rightmenu/rightbox.vue'
export default {
  components: { FoldTxt2, Rightbox,sRightmenu ,SurveyPop},
  name: 'sAr',
  mixins:[videoMixin],
  props: {show:Boolean, },
  data(){
    return{
       config,
       idName:'ar',
       develop:false,
       surveyVisible:false,
       videoId:''
    }
  },
  computed:{
    
  },
  mounted() {

  },
  
  methods:{
    addCount(){
      this.$api.userApi.getAccount({typeid:2})
    },
    getDetail(){
      let curMap =  config.site.find(t=>{return t.spot == parseInt(this.$route.query.spot)})
      this.$api.featureApi.getFeatureList({typeid:3,bigtype:curMap.spot}).then(res=>{
        if(res && res.data){
          this.showpath = res.showpath
          this.list = res.data
          this.videoId = this.list && this.list[0]?this.list[0].id:'' 
          if(this.list.length==0){
            this.develop = true
          }else{
            this.develop= false
          }
          setTimeout(() => {
            this.playCurr(0)
          }, 100);
          this.addCount()
        }
      })
    },

    menuClick(e){
      if(e.event=='home' || e.event =='back'){
        this.hide()
        return
      }
      this.$emit("changeMode",{
        old:"ar",
        new:e.event
      })
    },
    playEnd(){
      this.surveyVisible = true
    },
    surveyHide(){
      this.surveyVisible = false
      this.hide()
    }
    
    
  },
}
</script>
<style scoped lang="scss">
.build{
    background: #000;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16rem;
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 2;
    top: 0;
    .text{
      opacity: 0.7;
    }
  }
  
</style>